<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
      <v-tab @change="changetab('ID Proof Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        ID proof Setup
      </v-tab>
     
      <v-tab @change="changetab('Doc Type + Event - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       ID proof + Event Merge
      </v-tab>

      <v-tab-item >
        <idproof></idproof>
      </v-tab-item>
     
      <v-tab-item style="background-color:#e9e9e9;">
       <EventDoctypemerge></EventDoctypemerge>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import idproof from '../../../components/idproof'
import EventDoctypemerge from '../../../components/EventDoctypemerge.vue'
export default {
 components: {idproof,EventDoctypemerge},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>